/**
 * Polyfills para compatibilidad cross-browser
 */

// MediaRecorder polyfill para Safari iOS
export async function loadMediaRecorderPolyfill(): Promise<void> {
  if (typeof MediaRecorder === 'undefined' || !MediaRecorder.isTypeSupported) {
    try {
      const AudioRecorder = await import('audio-recorder-polyfill');
      (window as any).MediaRecorder = AudioRecorder.default || AudioRecorder;
    } catch (error) {
      // console.warn('MediaRecorder polyfill no disponible:', error);
    }
  }
}

// AudioContext polyfill para navegadores antiguos
export function getAudioContext(): AudioContext | null {
  const AudioContextClass = 
    (window as any).AudioContext || 
    (window as any).webkitAudioContext ||
    null;
  
  if (!AudioContextClass) {
    // console.warn('AudioContext no soportado en este navegador');
    return null;
  }

  return new AudioContextClass();
}

// IndexedDB polyfill si es necesario
export function checkIndexedDBSupport(): boolean {
  return 'indexedDB' in window;
}

// Cargar todos los polyfills necesarios
export async function loadPolyfills(): Promise<void> {
  try {
    const browserInfo = await import('./browserDetection')
      .then(m => m.detectBrowser())
      .catch(() => {
        // Si falla la detección del navegador, usar valores por defecto seguros
        // console.warn('[Polyfills] No se pudo detectar el navegador, usando valores por defecto');
        return {
          isSafariIOS: false,
          supportsMediaRecorder: true
        };
      });
    
    if (browserInfo.isSafariIOS && !browserInfo.supportsMediaRecorder) {
      await loadMediaRecorderPolyfill().catch(error => {
        // console.warn('[Polyfills] Error al cargar MediaRecorder polyfill:', error);
        // Continuar aunque falle el polyfill
      });
    }
  } catch (error) {
    // Si hay cualquier error, loguearlo pero no bloquear la inicialización
    // console.warn('[Polyfills] Error general al cargar polyfills:', error);
  }
}


